<div class="container col-md-16 provider-bottom">
  <div class="row cup-member-header">
    @if (!this.isOverallSearchResultSingle && !providerIdFromMember) {
      <div class="col-md-2 pull-left cup-back-button margin-top">
        @if (isProviderMapRequest) {
          <a [routerLink]="['../../../provider-search']" skipLocationChange routerLinkActive="active">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;&nbsp;BACK TO PROVIDER LIST</a>
          }
          @if (isAuthSummaryMapRequest) {
            <a  routerLinkActive="active" class="pointer" skipLocationChange (click)="backToAuthSummary()">
              <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;&nbsp;BACK TO AUTH SUMMARY</a>
            }
            @if (paramterPassed && !isProviderMapRequest && !pcpPassed) {
              <a [routerLink]="['../../provider-search']" skipLocationChange routerLinkActive="active">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;&nbsp;BACK TO SEARCH</a>
              }
              @if (!paramterPassed && !isProviderMapRequest && !isAuthSummaryMapRequest) {
                <a [routerLink]="['../provider-search']" skipLocationChange routerLinkActive="active">
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;&nbsp;BACK TO PROVIDER LIST</a>
                }
                @if (paramterPassed && pcpPassed) {
                  <a [routerLink]="['../../../provider-search']" skipLocationChange routerLinkActive="active">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;&nbsp;BACK TO SEARCH</a>
                  }
                </div>
              }

              @if (!isProviderMapRequest && !isAuthSummaryMapRequest) {
                <div class="col-md-12 marginTop dialog-alignment-auth">
                  <span class="rounded" title="{{providerDetailsData?.name}}" readonly>NAME - {{providerDetailsData?.name}}</span>
                  <span class="rounded" title="{{providerDetailsData?.internalId}}" readonly>INTERNAL ID - {{providerDetailsData?.internalId}}</span>
                </div>
              }
              @if (!isProviderMapRequest && !pcpName && !isAuthSummaryMapRequest && !providerIdFromMember) {
                <cup-traversal [traversalData]="selectedProvider" (traverseTowards)="traverseTowards($event)"></cup-traversal>
              }
            </div>
            <!-- <cup-traversal *ngIf="!isProviderMapRequest && !pcpName" [traversalData]="selectedProvider" (traverseTowards)="traverseTowards($event)"></cup-traversal> -->
          </div>
          <div class="container-fluid">

            <div class="col-md-16">
              @if (!isProviderMapRequest && !isAuthSummaryMapRequest) {
                <div class="tab" role="tabpanel">
                  <!-- Nav tabs -->
                  <ul class="nav nav-tabs cup-detail-header" role="tablist">
                    <li role="presentation" class="active">
                      <a href="#Section1" aria-controls="home" role="tab" data-toggle="tab">PROVIDER DETAILS</a>
                    </li>
                  </ul>
                  <!-- Tab panes -->
                  <div class="tab-content">
                    <div role="tabpanel" class="tab-pane active" id="Section1">
                      <div class="row">
                        <div class="col-md-5 providerDemo">
                          <h3> PROVIDER DETAILS </h3>
                        </div>
                        <div class="col-md-11 providerDemo">
                          <h3>
                            <span>CONTACTS BY SPECIALTY AND ADDRESS FOR - </span>
                            <span class="regionheader" title="{{ regions }}">REGION: {{ regions }}</span>
                          </h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-5">
                          <div class="row">
                            <div class="form-group col-md-8">
                              <label for="name">OFFICE / SPECIALTY</label>
                              <!-- <input name="name" id="name" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.office"
                              /> -->
                              <br>
                                <div class="office-special" title="{{providerDetailsData.office}}">{{providerDetailsData.office}}</div>
                              </div>
                              <div class="form-group col-md-8">
                                <label for="userSite">USER SITE</label>
                                <!--  <input name="userSite" id="userSite" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.userSite"/> -->
                                <br>
                                  <div class="user-site" title="{{ providerDetailsData.userSite }}">{{providerDetailsData.userSite}}</div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-8">
                                  <label for="taxId">TAX ID</label>
                                  <input name="taxId" id="taxId" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.taxId"
                                    />
                                  </div>
                                  <div class="form-group col-md-8">
                                    <label for="office">NPI</label>
                                    <input name="office" id="office" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.npiId"
                                      />
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="form-group col-md-16">
                                      <label for="office">SEARCHABLE TYPES</label>
                                      <span class="searchable-types" title="{{ providerDetailsData.searchableTypes }}">{{providerDetailsData.searchableTypes}}</span>
                                      <!-- <input name="office" id="office" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.searchableTypes"
                                      /> -->
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-11">
                                  <div class="row provider-details-grid">
                                    <cup-grid class="provider-pagination-hide" [ngClass]="{'member-pcp': providerIdFromMember}" [gridRows]="providerDetailsGridRow" [gridColumns]="providerDetailsColumns" [pageFromParent]="pageFromParent"
                                    [hideTabAlone]="hideTabAlone" [rowPerPageList]="[5,10,20,30]" [rowPerPage]="5" [masterProviderGrid]="'true'"></cup-grid>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="tab-content">
                          <div role="tabpanel" class="tab-pane active" id="Section1">
                            <div class="row">
                              <div class="col-md-16 providerDemo">
                                <h3> PROVIDER DETAILS </h3>
                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-5">
                                <label for="name">OFFICE / SPECIALITY</label>
                                <input name="name" id="name" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.office"
                                  />
                                </div>
                                <div class="form-group col-md-5">
                                  <label for="userSite">USER SITE</label>
                                  <input name="userSite" id="userSite" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.userSite"
                                    />
                                  </div>
                                  <div class="row">
                                    <div class="form-group col-md-5">
                                      <label for="name">OFFICE / SPECIALITY</label>
                                      <input name="name" id="name" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.office"
                                        />
                                      </div>
                                      <div class="form-group col-md-5">
                                        <label for="userSite">USER SITE</label>
                                        <input name="userSite" id="userSite" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.userSite"
                                          />
                                        </div>
                                        <div class="form-group col-md-3">
                                          <label for="taxId">TAX ID</label>
                                          <input name="taxId" id="taxId" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.taxId"
                                            />
                                          </div>
                                          <div class="form-group col-md-3">
                                            <label for="office">NPI</label>
                                            <input name="office" id="office" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.npiId"
                                              />
                                            </div>
                                            <div class="form-group col-md-10">
                                              <label for="office">SEARCHABLE TYPES</label>
                                              <input name="office" id="office" type="text" class="form-control input-underline" disabled [ngModel]="providerDetailsData.searchableTypes"
                                                />
                                              </div>
                                            </div>
                                            <div class="row Section2">
                                              <div class="col-md-16 providerDemo">
                                                <h3>
                                                  <span>CONTACTS BY SPECIALTY AND ADDRESS FOR - </span>
                                                  <span class="regionheader">REGION: {{ regions }}</span>
                                                </h3>
                                              </div>
                                            </div>
                                            <div class="row">
                                              <cup-grid [gridRows]="providerDetailsGridRow" [gridColumns]="providerDetailsColumns" [pageFromParent]="pageFromParent"></cup-grid>
                                            </div>
                                          </div>
                                        </div>
                                      </div> -->
                                    </div>
                                  }

                                  @if (isProviderMapRequest || isAuthSummaryMapRequest) {
                                    <div>
                                      <!-- <cup-map [source]="selectedProviderAddress" [destination]="selectedProviderDestination"></cup-map>/ -->
                                    </div>
                                  }
                                </div>

                              </div>